export default __webpack_public_path__ + "static/media/r1.d17403ba.webp";